module.exports = __webpack_public_path__ + "img/no-equipment-found-icon@2x.16bb701d.png";